import { Col, ColProps, Form, FormInstance, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { customerFilterFormId } from '../../../constants/constants';
import { CustomersFormFilterModel } from '../../../models/customers-form-filter-model';

interface Props {
  form: FormInstance<CustomersFormFilterModel>;
}

const CustomersFilterForm = ({ form }: Props): JSX.Element => {
  const columnsGrid: ColProps = { xs: 24, sm: 12, md: 6 };
  const { t } = useTranslation('common');

  return (
    <Form id={customerFilterFormId} form={form} layout="vertical">
      <Row gutter={18} align="bottom" justify="end">
        <Col flex="auto">
          <Row gutter={18}>
            <Col {...columnsGrid}>
              <Form.Item name="name" label={t('label.name')}>
                <Input placeholder={t('label.name')} />
              </Form.Item>
            </Col>
            <Col {...columnsGrid}>
              <Form.Item name="surname" label={t('label.surname')}>
                <Input placeholder={t('label.surname')} />
              </Form.Item>
            </Col>
            <Col {...columnsGrid}>
              <Form.Item name="email" label={t('label.email')} normalize={value => value.trim()}>
                <Input placeholder={t('label.email')} />
              </Form.Item>
            </Col>
            <Col {...columnsGrid}>
              <Form.Item name="phone" label={t('label.phone')}>
                <Input placeholder={t('label.phone')} />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default CustomersFilterForm;
